import type { ReactiveControllerHost } from 'lit';
import { CustomError } from '../../../../_ui-core_/base/package/patterns/package/CError';
import App from '../../../../app';
import BaseController, { type EventAction, type IGameController } from '../base-controller';

type HoelleEvent = {
  // There are more event types if needed
  type: 'gameReady' | 'roundStarted' | 'roundEnded';
};

export default class HoelleGameController extends BaseController implements IGameController {
  constructor(host: ReactiveControllerHost) {
    super(host, 'hoelle');
  }

  public async getLaunchUrl(forReal: boolean, gameId: string): Promise<string> {
    try {
      const info = await App.instance.casino.getGameLaunchInfo(this.provider, gameId, forReal);

      if (!info.launchConfig.launchUrl) {
        return Promise.reject(new CustomError('Launch URL is missing.', { code: 404 }));
      }

      return info.launchConfig.launchUrl;
    } catch (error: any) {
      return Promise.reject(
        new CustomError(`Failed to get game launch info: ${error.message}`, {
          code: error.code || 500,
          type: error.type,
        }),
      );
    }
  }

  public getLaunchUrlIOs(forReal: boolean, gameId: string, gameBaseUrl: string): Promise<string> {
    window.$app.logger.warn('TODO - NATIVE GAME LAUNCH NOT IMPLEMENTED!', gameBaseUrl);
    return this.getLaunchUrl(forReal, gameId); // TODO
  }

  public handleMessageEvent(data: HoelleEvent): EventAction | null {
    const { type } = data;
    window.$app.logger.log('message', data);
    switch (type) {
      case 'gameReady':
        return this.markActivity();
      case 'roundStarted':
        return this.markActivity();
      case 'roundEnded':
        return this.markActivityAndSpinSuccess();
      default:
        return null;
    }
  }

  public handleAdditionalEventListeners(_iframeUrl: string, _iframeEl: HTMLIFrameElement) {
    return;
  }
}
